export default __webpack_public_path__ + "static/media/255.47ed01cf.gif";